module.exports = __webpack_public_path__ + "img/Click2Call.79c088e7.png";